import { actionType } from '../../constants/Clients';
const initialState = {
  data: {
    content: [],
    number: 0,
    totalPages: 0,
    totalElements: 0,
    size: 10,
    isFetching: false,
  },
  error: null,
  saving: false,
};

export default (state = initialState, action) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case actionType.GET_CLIENTS_START:
      return {
        ...state,
        data: {
          ...state.data,
          isFetching: true,
        },
      };
    case actionType.GET_CLIENTS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
          isFetching: false,
        },
      };
    case actionType.GET_CLIENTS_FAIL:
      return {
        ...state,
        data: {
          ...state.data,
          isFetching: false,
        },
        error: action.payload,
      };
    case actionType.ADD_CLIENT_START:
      return {
        ...state,
        saving: true,
      };
    case actionType.ADD_CLIENT: {
      const newTotalElements = state.data.totalElements + 1;
      const dataContent = [...state.data.content];
      if (state.data.last) {
        dataContent.push(action.payload);
      }

      return {
        ...state,
        saving: false,
        data: {
          ...state.data,
          content: dataContent,
          totalElements: newTotalElements,
          totalPages: Math.ceil(newTotalElements / state.data.size),
        },
      };
    }
    case actionType.ADD_CLIENT_FAIL:
      return {
        ...state,
        error: action.payload,
        saving: false,
      };
    case actionType.CLIENTS_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
